module.exports = __webpack_public_path__ + "img/welfare-view-more-active.1d4ee327.png";